"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversations.favorite.add': 'Agregar a favoritos',
    'conversations.favorite.remove': 'Quitar de favoritos',
};
